import { inject, Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    GuardResult,
    MaybeAsync,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { PlannedAssignmentApi } from "@ramudden/data-access/resource/planned-assignment.api";
import { catchError, map, of } from "rxjs";
import { AppService } from "../services/app.service";
import { AssignmentService } from "../services/assignment.service";

@Injectable()
export class StillActiveGuard implements CanActivate {
    private readonly appService = inject(AppService);
    private readonly assignmentService = inject(AssignmentService);
    private readonly plannedAssignmentApi = inject(PlannedAssignmentApi);
    private readonly router = inject(Router);

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        return this.plannedAssignmentApi.get$(this.assignmentService.selectedPlannedAssignment.id).pipe(
            map((result) => {
                if (result === undefined || result === null) {
                    this.appService.clearState();
                    return this.router.createUrlTree(["/setup"]);
                }
                return true;
            }),
            catchError((_) => {
                this.appService.clearState();
                return of(this.router.createUrlTree(["/setup"]));
            }),
        );
    }
}
